import axios from './axiosService';

/**
 * MLD-2453
 */
export default {
  getBlockedRecipients() {
    return axios.get(`/api/blocked-recipients`)
      .then(response => response.data);
  },
  getBlockedRecipient(recipientID) {
    return axios.get(`/api/blocked-recipients/${recipientID}`)
      .then(response => response.data);
  },
  deleteRecipient(recipientID) {
    return axios.delete(`/api/blocked-recipients/${recipientID}`)
      .then(response => response.data);
  },
  async isBlocked(email) {
    const options = {
      params: {
        email
      }
    }
    return axios.get(`/api/blocked-recipients/check`, options)
      .then(response => {
        return response.data.is_blocked;
      })
      .catch(err => {
        return false;
      });
  }
}
